import { node } from "~/util/dom";
import { ICommonOpts } from "~/report/interfaces";

export default class ReportFormField {
	#opts: ICommonOpts;

	#fieldNode: HTMLDivElement;

	constructor(opts: ICommonOpts) {
		this.#opts = {
			...opts,
		};
		this.#build();
	}

	get container() {
		return this.#fieldNode;
	}

	#build() {
		const { parent, isHidden } = this.#opts;

		this.#fieldNode = node("div", { className: `form-field${isHidden ? " hidden" : ""}` });

		if (this.#opts.className) {
			this.#fieldNode.classList.add(this.#opts.className);
		}

		parent.append(this.#fieldNode);
	}

	hide() {
		this.#fieldNode.classList.add("hidden");
	}

	show() {
		this.#fieldNode.classList.remove("hidden");
	}
}
